import * as React from "react";

const SvgAvatar = props => <svg viewBox="0 0 234 247" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M58.5 58.5C58.5 90.753 84.747 117 117 117C149.253 117 175.5 90.753 175.5 58.5C175.5 26.247 149.253 0 117 0C84.747 0 58.5 26.247 58.5 58.5ZM221 247H234V234C234 183.833 193.167 143 143 143H91C40.82 143 0 183.833 0 234V247H221Z" fill="currentColor" fillOpacity={0.5} /></svg>;

export default SvgAvatar;